<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>payment</mat-icon>
      Tickets | {{ listingTitle }}
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-dialog-actions align="end">
      <mat-button-toggle-group
        #toggle="matButtonToggleGroup"
        (change)="setFilter(toggle.value)"
        [value]="filter"
        >
        <mat-button-toggle>
          <mat-icon>view_list</mat-icon>
          All
        </mat-button-toggle>
        <mat-button-toggle value="live">
          <mat-icon>power_settings_new</mat-icon>
          Live
        </mat-button-toggle>
        <mat-button-toggle value="sold">
          <mat-icon>new_releases</mat-icon>
          Sold Out
        </mat-button-toggle>
      </mat-button-toggle-group>
    </mat-dialog-actions>
    @if (!loading) {
      <mat-accordion class="ticket-locations">
        @for (location of Data; track location) {
          <mat-expansion-panel
            (opened)="setPanel(location)"
            [expanded]="selectedLocation == location"
            hideToggle="true"
            >
            <mat-expansion-panel-header>
              <mat-panel-title> {{ location.title }} </mat-panel-title>
              <mat-panel-description>
                &nbsp;
                <mat-chip class="count"
                  >{{getEventsWithTickets(Data, location).length }}</mat-chip
                  >
                </mat-panel-description>
              </mat-expansion-panel-header>
              <ng-container>
                <mat-table #table [dataSource]="getEventsWithTickets(Data, location)">
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.startDate }} {{row.startTime ? ' - ' + row.startTime.name
                      : ''}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unreleasedTickets">
                    <th mat-header-cell *matHeaderCellDef>Unreleased Tickets</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.unreleasedTickets }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="ticketsSold">
                    <th mat-header-cell *matHeaderCellDef>Tickets Sold</th>
                    <td mat-cell *matCellDef="let row">{{ row.ticketsSold }}</td>
                  </ng-container>
                  <ng-container matColumnDef="ticketsAvailable">
                    <th mat-header-cell *matHeaderCellDef>Tickets Available</th>
                    <td mat-cell *matCellDef="let row">{{ row.ticketsAvailable }}</td>
                  </ng-container>
                  <ng-container matColumnDef="totalTickets">
                    <th mat-header-cell *matHeaderCellDef>Total Tickets</th>
                    <td mat-cell *matCellDef="let row">{{ row.totalTickets }}</td>
                  </ng-container>
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Price</th>
                    <td mat-cell *matCellDef="let row">
                      {{ getDisplayPrice(row) | currency : 'GBP' : 'symbol-narrow' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="actions">
                      <button
                        (click)="editItem(location)"
                        mat-icon-button
                        matTooltip="Add ticket"
                        >
                        <mat-icon>add</mat-icon>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let row" class="actions">
                      <mat-button-toggle-group>
                        <button
                          (click)="listSold(row)"
                          [disabled]="row.ticketsSold === 0"
                          mat-icon-button
                          matTooltip="Guest list"
                          >
                          <mat-icon>list</mat-icon>
                        </button>
                        <button
                          (click)="copyItem(location,row)"
                          mat-icon-button
                          matTooltip="Copy ticket"
                          >
                          <mat-icon>content_copy</mat-icon>
                        </button>
                        <button
                          (click)="editItem(location, row)"
                          mat-icon-button
                          matTooltip="Edit ticket"
                          >
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button
                          (click)="deleteItem(location, row)"
                          mat-icon-button
                          matTooltip="Delete ticket"
                          >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </mat-button-toggle-group>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns;"
                    [ngClass]="{disabled: disableRow(row) }"
                  ></tr>
                </mat-table>
              </ng-container>
            </mat-expansion-panel>
          }
          @if (!loading && !Data.length) {
            <mat-card class="no-results">
              <mat-card-content>
                <mat-icon>payment</mat-icon>
                No tickets
              </mat-card-content>
            </mat-card>
          }
        </mat-accordion>
      }
    </section>
    <section align="end" mat-dialog-actions>
      <button
        (click)="addLocation()"
        mat-button
        matTooltip="Add ticket location"
        type="button"
        >
        <mat-icon>add</mat-icon>
        Add Location
      </button>
    </section>
  </section>
